import { render, staticRenderFns } from "./Weeks.vue?vue&type=template&id=32550057&scoped=true&"
import script from "./Weeks.vue?vue&type=script&lang=js&"
export * from "./Weeks.vue?vue&type=script&lang=js&"
import style0 from "./Weeks.vue?vue&type=style&index=0&id=32550057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32550057",
  null
  
)

export default component.exports